<template>
  <div v-cloak class="view-wrap">
    <div class="view-content">
      <onboard-wrap>
        <h1>Sorry! It looks like this invite has expired.</h1>
        <p>Please check with your admin to get a new invite.</p>
        <a href="/" class="btn btn-lg">Go Home</a>
      </onboard-wrap>
    </div>
  </div>
</template>

<script>
import teamWrap from '@/components/team-wrap/team-wrap'

export default {
  name: 'invalid',
  components: {
    'onboard-wrap': teamWrap
  },
  data () {
    return {}
  }
}
</script>

<style scoped lang="stylus" src="./invalid.styl" >



// WEBPACK FOOTER //
// src/views/invalid/invalid.vue